import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { base_url } from "../../utils/utils";

export const get_deleted_report_list = createAsyncThunk(
  "deleted_report_list",
  async (data) => {
    const userIdString = localStorage.getItem("userId");
    const userId = JSON.parse(userIdString)?.aid;
    
    const body = new FormData();
    body.append("action", data.action || "list");
    body.append("agencyid", userId);
    if (data.fd) body.append("fd", data.fd);
    if (data.td) body.append("td", data.td);
    if (data.page) body.append("page", data.page);
    if (data.limit) body.append("limit", data.limit);

    const response = await fetch(
      base_url + "reports/deleted_report.php",
      {
        method: "POST",
        body: body,
      }
    );
    const res = await response.json();
    return res;
  }
);

const initialState = {
  deleted_report_list: [],
  loading: false,
  error: null,
  totalCount: 0,
  searchCount: 0,
};

const deletedReportSlice = createSlice({
  name: "deletedReport",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(get_deleted_report_list.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(get_deleted_report_list.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.success) {
          state.deleted_report_list = action.payload?.data || [];
          state.totalCount = action.payload?.totalcount || 0;
          state.searchCount = action.payload?.searchcount || 0;
        }
      })
      .addCase(get_deleted_report_list.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default deletedReportSlice.reducer;
